import React, { useState } from "react";
import { Box } from "@chakra-ui/react";
import { Button } from "@chakra-ui/react";

export default function WartungsprotokollSeite3({ form, setForm }) {
  
  const [showZusatz1, setShowZusatz1] = useState(false);
  const [showZusatz2, setShowZusatz2] = useState(false);

  if (!form) return null;

  

  const updateVerschattung = (idx, field) => {
    setForm(prev => {
      const list = [...(prev.verschattung || [])];
      list[idx] = { ja: field === "ja", nein: field === "nein", nz: field === "nz" };
      return { ...prev, verschattung: list };
    });
  };

  const updateAnlageZustand = (idx, field) => {
    setForm(prev => {
      const list = [...(prev.anlageZustand || [])];
      list[idx] = { ja: field === "ja", nein: field === "nein", nz: field === "nz" };
      return { ...prev, anlageZustand: list };
    });
  };

  const updateZusatz = (key, idx, field, value) => {
    setForm(prev => {
      const copy = [...(prev[key] || [])];
      copy[idx] = { ...(copy[idx] || {}), [field]: value };
      return { ...prev, [key]: copy };
    });
  };

  const updateZusatzBeh = (key, idx, field, value) => {
    setForm(prev => {
      const copy = [...(prev[key] || [])];
      copy[idx] = {
        ...(copy[idx] || {}),
        beh: field === "beh" ? value : false,
        nbeh: field === "nbeh" ? value : false
      };
      return { ...prev, [key]: copy };
    });
  };

  return (

    <div className="p-6 space-y-10 mb-16">
      {/* SECTION 1 */}
      <Box p={8} bg="white" borderRadius="xl" boxShadow="md" mt={3} mb={3}>
        <h2 style={{ fontWeight: "bold" }}>
          1- Kontrolle der Anlage auf Verschattung 
        </h2>

        <table className="w-full mb-6 text-xs" style={{ borderCollapse: "collapse", width: "100%" }}>
               <thead>
          <tr className="border-b font-semibold text-center">
            <th className="p-2 w-2/3 text-left"></th>
            <th className="p-2 min-w-[90px]">ja</th>
            <th className="p-2 min-w-[90px]">nein</th>
            <th className="p-2 min-w-[90px]">nicht zutreffend</th>
          </tr>
        </thead>
          <tbody>
            {[
              "1.1 Die Anlage ist frei von dauerhafter Umgebungsverschattung (zB Aufbauten)",
              "1.2 Die Anlage ist frei von temporärer Umgebungsverschattung (zB Bewuchs)",
              "1.3 Die Anlage ist frei von eigener Verschattung",
            ].map((text, idx) => (
              <tr key={idx}>
                <td style={{ border: "1px solid #ccc", padding: "4px", width: "70%" }}>
                  {text}
                </td>

                <td style={{ border: "1px solid #ccc", textAlign: "center" }}>
                  <input
                    type="checkbox"
                    checked={form.verschattung?.[idx]?.ja || false}
                    onChange={() => updateVerschattung(idx, "ja")}
                  />
                </td>

                <td style={{ border: "1px solid #ccc", textAlign: "center" }}>
                  <input
                    type="checkbox"
                    checked={form.verschattung?.[idx]?.nein || false}
                    onChange={() => updateVerschattung(idx, "nein")}
                  />
                </td>

                <td style={{ border: "1px solid #ccc", textAlign: "center" }}>
                  <input
                    type="checkbox"
                    checked={form.verschattung?.[idx]?.nz || false}
                    onChange={() => updateVerschattung(idx, "nz")}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <Box mb={3} mt={4}>

        <Button
          onClick={() => setShowZusatz1(!showZusatz1)}
          colorScheme="blue"
          borderRadius="lg"
        >
          {showZusatz1 ? "Zusatz-Tabelle minimieren" : "Zusatz-Tabelle anzeigen"}
        </Button>

        </Box>

        {/* ZUSATZ-TABELLE #1 */}
         {showZusatz1 && (
  <>
        <h3 className="font-semibold mb-2 mt-4">Zusatz-Tabelle</h3>

        <table className="w-full mb-6 text-xs" style={{ borderCollapse: "collapse", width: "100%" }}>
          <thead>
            <tr>
              <th style={{ border: "1px solid #ccc", padding: "4px", width: "15%" }}>Zu Punkt</th>
              <th style={{ border: "1px solid #ccc", padding: "4px", width: "45%" }}>Bemerkungen / Mängel</th>
              <th style={{ border: "1px solid #ccc", padding: "4px", width: "15%" }}>Standort Mangel</th>
              <th style={{ border: "1px solid #ccc", padding: "4px", width: "5%" }}>Plan</th>
              <th style={{ border: "1px solid #ccc", padding: "4px", width: "10%" }}>Bild-Nr.</th>
              <th style={{ border: "1px solid #ccc", padding: "4px", width: "5%" }}>Beh.</th>
              <th style={{ border: "1px solid #ccc", padding: "4px", width: "5%" }}>n. Beh.</th>
            </tr>
          </thead>

          <tbody>
            {(form.zusatz1 || []).map((row, idx) => (
              <tr key={idx}>
                {["zupunkt", "bemerkung", "standort"].map(field => (
                  <td key={field} style={{ border: "1px solid #ccc", padding: "2px" }}>
                    <input
                      type="text"
                      value={row?.[field] ?? ""}
                      onChange={e => updateZusatz("zusatz1", idx, field, e.target.value)}
                      style={{ width: "100%", border: "none", backgroundColor: "#f7f7fb" }}
                    />
                  </td>
                ))}

                <td style={{ border: "1px solid #ccc", textAlign: "center" }}>
                  <input
                    type="checkbox"
                    checked={row?.plan || false}
                    onChange={() => updateZusatz("zusatz1", idx, "plan", !row?.plan)}
                  />
                </td>

                <td style={{ border: "1px solid #ccc", padding: "2px" }}>
                  <input
                    type="text"
                    value={row?.bildnr ?? ""}
                    onChange={e => updateZusatz("zusatz1", idx, "bildnr", e.target.value)}
                    style={{ width: "100%", border: "none", backgroundColor: "#f7f7fb" }}
                  />
                </td>

                <td style={{ border: "1px solid #ccc", textAlign: "center" }}>
                  <input
                    type="checkbox"
                    checked={row?.beh || false}
                    onChange={() => updateZusatzBeh("zusatz1", idx, "beh", !row?.beh)}
                  />
                </td>

                <td style={{ border: "1px solid #ccc", textAlign: "center" }}>
                  <input
                    type="checkbox"
                    checked={row?.nbeh || false}
                    onChange={() => updateZusatzBeh("zusatz1", idx, "nbeh", !row?.nbeh)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
          </>
       )}

      </Box>

      <Box p={8} bg="white" borderRadius="xl" boxShadow="md" mt={3} mb={3}>

        {/* SECTION 2 */}
        <h2 style={{ fontWeight: "bold" }}>
          2- Sichtkontrolle der Module auf Beschädigung und Verschmutzung
        </h2>

        <table className="w-full mb-6 text-xs" style={{ borderCollapse: "collapse", width: "100%" }}>
                  <thead>
          <tr className="border-b font-semibold text-center">
            <th className="p-2 w-2/3 text-left"></th>
            <th className="p-2 min-w-[90px]">ja</th>
            <th className="p-2 min-w-[90px]">nein</th>
            <th className="p-2 min-w-[90px]">nicht zutreffend</th>
          </tr>
        </thead>
          <tbody>
            {[
              "2.1 Die Oberfläche der Module ist frei von Beschädigungen",
              "2.2 Die Rahmen der Module sind frei von Beschädigungen",
              "2.3 Die Glasoberfläche der Module ist frei von Verschmutzung (Foto!)",
              "2.4 Die Zellen in den Modulen sind frei von Auffälligkeiten",
              "2.5 Die Einbettungsfolie ist frei von Auffälligkeiten",
              "2.6 Die Rückseitenfolie der Module ist frei von Beschädigungen",
              "2.7 Die Modulanschlussdosen sind frei von Auffälligkeiten",
              "2.8 Die Typenschilder und SN-Aufkleber sind frei von Auffälligkeiten",
              "2.9 Die Module wurden gereinigt",
            ].map((text, idx) => (
              <tr key={idx}>
                <td style={{ border: "1px solid #ccc", padding: "4px", width: "70%" }}>
                  {text}
                </td>

                <td style={{ border: "1px solid #ccc", padding: "4px", width: "10%", textAlign: "center" }}>
                  <input
                    type="checkbox"
                    checked={form.anlageZustand?.[idx]?.ja || false}
                    onChange={() => updateAnlageZustand(idx, "ja")}
                  />
                </td>

                <td style={{ border: "1px solid #ccc", padding: "4px", width: "10%", textAlign: "center" }}>
                  <input
                    type="checkbox"
                    checked={form.anlageZustand?.[idx]?.nein || false}
                    onChange={() => updateAnlageZustand(idx, "nein")}
                  />
                </td>

                <td style={{ border: "1px solid #ccc", padding: "4px", width: "10%", textAlign: "center" }}>
                  <input
                    type="checkbox"
                    checked={form.anlageZustand?.[idx]?.nz || false}
                    onChange={() => updateAnlageZustand(idx, "nz")}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* VERSCHMUTZUNGSGRAD */}
        <Box p={4} borderWidth="1px" borderRadius="md" mt={3} mb={3} maxW="400px">
          <h3 style={{ fontWeight: "bold" }}>VERSCHMUTZUNGSGRAD</h3>


          <div className="flex flex-wrap gap-6 mb-8">
            {[
              [" leicht", "verschmutzungLeicht"],
              [" mittel", "verschmutzungMittel"],
              [" stark", "verschmutzungStark"],
              [" partiell", "verschmutzungPartiell"],
              [" flächig", "verschmutzungFlaechig"],
              [" Rand", "verschmutzungRand"],
            ].map(([label, field]) => (
              <Box
                key={field}
                p={3}
                borderWidth="1px"
                borderRadius="md"
                minW="160px"
                display="inline-flex"
                alignItems="center"
                width="200px"   // 👈 fixed width
              >
                <label className="flex items-center gap-3">
                  <input
                    type="checkbox"
                    className="w-4 h-4 mr-2"
                    checked={form?.[field] || false}
                    onChange={e => setForm(f => ({ ...f, [field]: e.target.checked }))}
                  />
                  {label}
                </label>
              </Box>
            ))}
          </div>
        </Box>

        {/* REINIGUNG EMPFOHLEN */}
        <Box p={4} borderWidth="1px" borderRadius="md" mt={3} mb={3} maxW="400px">
          <h3 style={{ fontWeight: "bold" }}>REINIGUNG EMPFOHLEN</h3>

          <div className="flex mb-6 text-xs w-full" style={{ gap: "90px" }}>
            <Box p={3} borderWidth="1px" borderRadius="md" width="120px">
              <label className="flex items-center gap-2">
                <input
                  type="checkbox"
                  className="mr-2"
                  checked={form.reinigungEmpfohlenJa || false}
                  onChange={e =>
                    setForm(f => ({
                      ...f,
                      reinigungEmpfohlenJa: e.target.checked,
                      reinigungEmpfohlenNein: false,
                    }))
                  }
                />
                {"  "}ja
              </label>
            </Box>

            <Box p={3} borderWidth="1px" borderRadius="md" width="120px" mb={3}>
              <label className="flex items-center gap-2">
                <input
                  type="checkbox"
                  className="mr-2"
                  checked={form.reinigungEmpfohlenNein || false}
                  onChange={e =>
                    setForm(f => ({
                      ...f,
                      reinigungEmpfohlenNein: e.target.checked,
                      reinigungEmpfohlenJa: false,
                    }))
                  }
                />
                {" "}nein 
              </label>
            </Box>
          </div>
        </Box>


        <Box mb={3} mt={4}>
        <Button
          onClick={() => setShowZusatz2(!showZusatz2)}
          colorScheme="blue"
          borderRadius="lg"
        >
          {showZusatz2 ? "Zusatz-Tabelle minimieren" : "Zusatz-Tabelle anzeigen"}
        </Button>
        </Box>


         {showZusatz2 && (
          <>
        {/* ZUSATZ-TABELLE #2 */}
        <h3 className="font-semibold mb-2 mt-4">Zusatz-Tabelle</h3>

        <table className="w-full mb-6 text-xs" style={{ borderCollapse: "collapse", width: "100%" }}>
          <thead>
            <tr>
              <th style={{ border: "1px solid #ccc", padding: "4px", width: "15%" }}>Zu Punkt</th>
              <th style={{ border: "1px solid #ccc", padding: "4px", width: "45%" }}>Bemerkungen / Mängel</th>
              <th style={{ border: "1px solid #ccc", padding: "4px", width: "15%" }}>Standort Mangel</th>
              <th style={{ border: "1px solid #ccc", padding: "4px", width: "5%" }}>Plan</th>
              <th style={{ border: "1px solid #ccc", padding: "4px", width: "10%" }}>Bild-Nr.</th>
              <th style={{ border: "1px solid #ccc", padding: "4px", width: "5%" }}>Beh.</th>
              <th style={{ border: "1px solid #ccc", padding: "4px", width: "5%" }}>n. Beh.</th>
            </tr>
          </thead>

          <tbody>
            {(form.zusatz2 || []).map((row, idx) => (
              <tr key={idx}>
                {["zupunkt", "bemerkung", "standort"].map(field => (
                  <td key={field} style={{ border: "1px solid #ccc", padding: "2px" }}>
                    <input
                      type="text"
                      value={row?.[field] ?? ""}
                      onChange={e => updateZusatz("zusatz2", idx, field, e.target.value)}
                      style={{ width: "100%", border: "none", backgroundColor: "#f7f7fb" }}
                    />
                  </td>
                ))}

                <td style={{ border: "1px solid #ccc", textAlign: "center" }}>
                  <input
                    type="checkbox"
                    checked={row?.plan || false}
                    onChange={() => updateZusatz("zusatz2", idx, "plan", !row?.plan)}
                  />
                </td>

                <td style={{ border: "1px solid #ccc", padding: "2px" }}>
                  <input
                    type="text"
                    value={row?.bildnr ?? ""}
                    onChange={e => updateZusatz("zusatz2", idx, "bildnr", e.target.value)}
                    style={{ width: "100%", border: "none", backgroundColor: "#f7f7fb" }}
                  />
                </td>

                <td style={{ border: "1px solid #ccc", textAlign: "center" }}>
                  <input
                    type="checkbox"
                    checked={row?.beh || false}
                    onChange={() => updateZusatzBeh("zusatz2", idx, "beh", !row?.beh)}
                  />
                </td>

                <td style={{ border: "1px solid #ccc", textAlign: "center" }}>
                  <input
                    type="checkbox"
                    checked={row?.nbeh || false}
                    onChange={() => updateZusatzBeh("zusatz2", idx, "nbeh", !row?.nbeh)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        </>
           )}
      </Box>
       
    </div>
  );
}